/**
 * Resources that have a server-side search cache. Mirrors the supported
 * argument of `invalidateSearchCacheAction`.
 *
 * Lives in a separate file from `search-cache-actions.ts` because
 * server action files (`"use server"`) may only export async functions —
 * type/const exports must live elsewhere.
 */
export const SEARCH_CACHE_RESOURCES = [
  "contacts",
  "companies",
  "deals",
  "tickets",
  "communications",
  "tasks",
] as const;

export type SearchCacheResource = (typeof SEARCH_CACHE_RESOURCES)[number];

/**
 * Type guard — true if the given entity name corresponds to a resource with
 * a server-side search cache. Use this at call sites that have a generic
 * `entityName: string` (e.g. `useCrudHandlers`) to avoid `as any` casts.
 */
export function isSearchCacheResource(entityName: string): entityName is SearchCacheResource {
  return (SEARCH_CACHE_RESOURCES as readonly string[]).includes(entityName);
}
